<template>
  <ul class="list-group">
    <li
      @click="showDetail(t)"
      class="list-group-item list-group-item-action d-flex align-items-center bd-0"
      v-for="(t, i) in tasks"
      :key="i"
      role="button"
    >
      <div class="avatar">
        <span :class="`avatar-initial rounded bg-transparent`">
          <img :src="`${getIdFromUrl(t.taskDesc)}`" class="rounded" />
        </span>
      </div>
      <div class="pd-l-10">
        <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
        <span class="tx-11 text-uppercase">
          <feather
            :type="t.isCompleted ? 'check-square' : 'square'"
            stroke-width="1"
            class="mg-r-5 tx-color-01"
          ></feather>
          youtube video
        </span>
      </div>
      <button
        class="btn btn-xs btn-outline-light btn-uppercase d-flex mg-l-auto"
      >
        <span class="mg-r-5">үзэх</span>
        <feather type="eye"></feather>
      </button>
    </li>
  </ul>
  <!-- <div class="row row-xs">
    <div
      class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-2"
      v-for="(t,i) in tasks"
      :key="i"
    >
      <div @click="showDetail(t)" class="card pd-10" role="button">
        <img    :src="`${getIdFromUrl(t.taskDesc)}`" class="ht-6v" />
        <div class="card-body pd-x-5 pd-t-5 pd-b-0 d-flex align-items-center">
          <div class="avatar avatar-sm mg-r-10 wd-18p">
            <span
              :class="`avatar-initial rounded-circle bg-${t.isCompleted?'success-light':'gray-700'}`"
            >
              <feather style="margin-top:-4px;" :type="t.isCompleted?'check':'youtube'" :size="16"></feather>
            </span>
          </div>
          <div class="wd-80p">
            <span>{{t.task}}</span>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { getIdFromUrl } from "vue-youtube";

export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getIdFromUrl(url) {
      let img = getIdFromUrl(url);
      if (img != null) return `http://img.youtube.com/vi/${img}/0.jpg`;
      else return "assets/img/img22.png";
    },
    showDetail(t) {
      if (this.$route.params.bot == 122) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: this.box.id,
            iid: t.id,
            bot: this.box.ot
          }
        });
      }
    }
  }
};
</script>

<style></style>
